import React from 'react';
import styled from 'styled-components';
import { Radio } from 'partials/formElements';
import shortid from 'shortid';

export const RadioButton = props => {
    const { data, idx, checked, available, collision } = props;
    const id = shortid.generate();
    return (
        <Wrapper available={available} collision={collision && !checked}>
            <Radio 
                type="radio" 
                name={"course-option-" + idx + id} //To do 
                checked={checked}
                onChange={() => props.handleOnChange(data, idx)}
                white
            />
        </Wrapper>
    )
}

export default RadioButton;

const Wrapper = styled.div`
    opacity: ${props => props.available && !props.collision ? 1 : .4};
    margin-right: -10px; 
    @media(max-width: 767px){
        margin-right: 2px;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/courseSelect/RadioButton.js